/**
 * @generated SignedSource<<3def072b3642eebc7f603c255a7d7001>>
 * @relayHash 46d80add7a778b67da31edb1f687bd7a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 08155c44de841eac3965582bc848489533dba90301356f14d4303d7fe9d61942

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedStoryPointEstimateFieldQuery } from './decomposedStoryPointEstimateFieldQuery.graphql';

const node: PreloadableConcreteRequest<decomposedStoryPointEstimateFieldQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "08155c44de841eac3965582bc848489533dba90301356f14d4303d7fe9d61942",
    "metadata": {},
    "name": "decomposedStoryPointEstimateFieldQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
